<template>
    <div class="search-module">

        <not-allowed v-if="!AllowedDisplay" :page="page" :module="idmodule" :data="datas"></not-allowed>

        <v-btn
            v-if="AllowedDisplay && show && $vuetify.breakpoint.xsOnly"
            :block="$vuetify.breakpoint.xsOnly"
            small
            depressed
            class="search-module__toggle search-module__theme-button mb-1"
            :aria-expanded="searchExpanded ? 'true' : 'false'"
            :aria-controls="`search-module-fields-${idmodule}`"
            @click="searchExpanded = !searchExpanded"
        >
            <v-icon left small>mdi-magnify</v-icon>
            Rechercher dans la page
            <v-icon right small>{{ searchExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>

        <v-expand-transition>
        <v-form v-if="AllowedDisplay" v-show="!$vuetify.breakpoint.xsOnly || searchExpanded" @submit.prevent="launchSearch"
            :id="`search-module-fields-${idmodule}`"
            ref="form"
            v-model="valid"
            lazy-validation
            class="search-module__form"
        >
                <v-row dense align="start" class="search-module__simple-fields">
                    <v-col v-for="(item, i) in list" :key="item.value || i" cols="12" sm="6" md="4" lg="3" class="search-module__field">
                    <component 
                        :is="getFieldComponent(item.format)" 
                        :item="item" 
                        :keyup="onkeyup" 
                        type="search"
                        :change="onChange" 
                        :page="page"  
                        :valField="getFieldResult(item)"
                        /> 
                    </v-col>

                <v-col v-if="datesearch.setdebdate || datesearch.setfindate || datesearch.setmonth" cols="12" class="search-module__dates">

                <v-row dense align="center">
                    <v-col v-if="datesearch.setdebdate && itemdateDeb" cols="12" sm="6" md="4">
                        <v-menu v-model="menudeb"                       
                        :close-on-content-click="false" transition="scale-transition"
                        min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">                                    
                                <v-btn v-bind="attrs" v-on="on" block outlined class="search-module__date-button search-module__theme-button">
                                    <v-icon left small>mdi-calendar-start</v-icon>
                                    <span class="text-truncate">{{ itemdateDeb.name }} : {{ (itemdateDeb.dateString!='N.D.') ? moment(itemdateDeb.dateString).format('DD/MM/YYYY') : "" }}</span>
                                </v-btn>
                            </template>
                            <v-card class="search-module__date-card">
                            <v-card-title class="text-subtitle-2 py-2">{{ itemdateDeb.name }}</v-card-title>
                            <v-date-picker
                            v-model="itemdateDeb.dateString"
                            @change="(mod) => {onDateChange(mod,'deb')}"
                            locale="fr"
                            no-title
                            full-width
                            scrollable>
                            </v-date-picker>
                            <v-card-actions class="justify-end"><v-btn text color="primary" @click="erase('start')">Effacer</v-btn></v-card-actions>
                            </v-card>
                        </v-menu>
                    </v-col>

                    <v-col v-if="datesearch.setfindate" cols="12" sm="6" md="4">
                        <v-menu v-model="menufin"                         
                        :close-on-content-click="false" transition="scale-transition" 
                        min-width="auto">
                            <template v-slot:activator="{ on, attrs }">                                    
                                <v-btn v-bind="attrs" v-on="on" block outlined class="search-module__date-button search-module__theme-button">
                                    <v-icon left small>mdi-calendar-end</v-icon>
                                    <span class="text-truncate">{{ itemdateFin.name }} : {{ (itemdateFin.dateString!='N.D.') ? moment(itemdateFin.dateString).format('DD/MM/YYYY') : "" }}</span>
                                </v-btn>
                            </template>
                        <v-card class="search-module__date-card">
                            <v-card-title class="text-subtitle-2 py-2">{{ itemdateFin.name }}</v-card-title>
                            <v-date-picker
                            v-model="itemdateFin.dateString"
                            @change="(mod) => {onDateChange(mod,'fin')}"
                            locale="fr"
                            no-title
                            full-width
                            scrollable>
                            </v-date-picker>
                            <v-card-actions class="justify-end"><v-btn text color="primary" @click="erase('end')">Effacer</v-btn></v-card-actions>
                        </v-card>
                        </v-menu>
                    </v-col>
                    <v-col v-if="datesearch.setmonth" cols="12" md="4">
                            <div class="search-module__months">
                                <v-btn icon small class="search-module__theme-button" aria-label="Mois précédents" @click="prevMonths"><v-icon>mdi-chevron-left</v-icon></v-btn>
                                <v-hover v-slot="{ hover }" v-for="mois in displayedMonths" :key="mois.mois">
                                    <div @click="selectMonth(mois)" class="search-module__month text-center text-caption">
                                        <v-tooltip bottom >
                                            <template v-slot:activator="{ on, attrs }">
                                               <div :class="['rounded pa-2', hover ? 'search-module__month--hover' : '', mois.highlighted ? 'search-module__month--active white--text' : '']" v-bind="attrs" v-on="on">{{ mois.mois }}</div>
                                            </template>
                                           {{ mois.title }}
                                        </v-tooltip>
                                    </div>
                                </v-hover>
                                <v-btn icon small class="search-module__theme-button" aria-label="Mois suivants" @click="nextMonths"><v-icon>mdi-chevron-right</v-icon></v-btn>
                            </div>
                    </v-col>
                </v-row>





                </v-col>
    
    
                </v-row>
                
                <div v-if="advancedConfig.enabled && advancedFields.length" class="mt-1">
                    <div class="d-flex flex-wrap align-center">
                        <v-btn x-small depressed color="secondary" :disabled="advancedConditions.length >= advancedConfig.maxconditions" @click="addAdvancedCondition">Ajouter un filtre avancé</v-btn>
                        <v-btn v-if="advancedConditions.length" x-small depressed color="warning" class="ml-2" @click="clearAdvancedConditions">Effacer</v-btn>
                    </div>
                    <div v-if="advancedConditions.length" class="pt-1">
                    <v-select v-if="advancedConditions.length > 1" v-model="advancedLogic"
                        :items="[{text:'Toutes les conditions (ET)',value:'and'},{text:'Au moins une condition (OU)',value:'or'}]"
                        label="Combinaison" dense outlined hide-details class="mb-2" @change="launchSearch" />
                    <v-row v-for="(condition,index) in advancedConditions" :key="index" dense align="center" class="mb-1">
                        <v-col cols="12" sm="4">
                            <v-select :value="condition.field ? condition.table + '::' + condition.field : ''" :items="advancedFieldOptions"
                                label="Champ" dense outlined hide-details @change="value => changeAdvancedField(condition,value)" />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-select v-model="condition.op" :items="advancedOperators(condition)"
                                label="Condition" dense outlined hide-details :disabled="!condition.field" @change="launchSearch" />
                        </v-col>
                        <v-col v-if="condition.field && condition.op !== 'empty' && condition.op !== 'not_empty'" cols="10" sm="4">
                            <v-select v-if="advancedIsSwitch(condition)" :value="condition.value"
                                :items="[{text:'ON',value:1},{text:'OFF',value:0}]" label="Valeur"
                                clearable dense outlined hide-details @change="value => changeAdvancedSwitch(condition, value)" />
                            <v-autocomplete v-else-if="advancedHasChoices(condition)"
                                :value="advancedSelectedValues(condition)" :items="advancedChoiceOptions(condition)"
                                multiple clearable dense outlined hide-details label="Choix" class="mb-0"
                                :loading="advancedChoiceLoading[condition.table + '::' + condition.field]"
                                :no-filter="!!(advancedField(condition) && advancedField(condition).dynamicsearch)"
                                @update:search-input="value => searchAdvancedChoices(condition, value)"
                                @change="values => changeAdvancedChoices(condition, values)">
                                <template v-slot:selection="{ item, index }">
                                    <span v-if="index === 0" class="text-truncate">{{ item.text }}</span>
                                    <span v-if="index === 1" class="grey--text caption ml-1">+{{ advancedSelectedValues(condition).length - 1 }}</span>
                                </template>
                            </v-autocomplete>
                            <div v-else class="search-module__advanced-values">
                            <v-text-field v-model="condition.value" :type="advancedInputType(condition)"
                                :label="condition.op === 'between' ? 'De' : 'Valeur'" dense outlined hide-details
                                @input="scheduleSearch" @keyup.enter="launchSearch" />
                            <v-text-field v-if="condition.op === 'between'" v-model="condition.value2"
                                :type="advancedInputType(condition)" label="À" dense outlined hide-details class="ml-1"
                                @input="scheduleSearch" @keyup.enter="launchSearch" />
                            </div>
                        </v-col>
                        <v-col cols="2" sm="1" class="text-center"><v-btn small icon color="error" aria-label="Supprimer ce filtre" @click="removeAdvancedCondition(index)"><v-icon small>mdi-close</v-icon></v-btn></v-col>
                    </v-row>
                    </div>
                </div>
        </v-form>
        </v-expand-transition>
    </div>
    </template>
    
    
    
    <script>
import { client } from '../mixins';
        export default {

            name : 'searchClient',

        mixins : [client],

            data: function() {
    
                return {
                    AllowedDisplay : true,
                    valid : true,
                    // Ouvert sur ordinateur, replié sur mobile pour préserver la hauteur utile.
                    searchExpanded: !this.$vuetify.breakpoint.xsOnly,
                    list : [],
                    advancedFields: [],
                    advancedConditions: [],
                    advancedDynamicChoices: {},
                    advancedChoiceLoading: {},
                    advancedChoiceTimers: {},
                    advancedLogic: 'and',
                    advancedConfig: {enabled:true,maxconditions:20,defaultlogic:'and'},
                    menudeb : false,
                    menufin :false,
                    monthDates : { end : this.moment().endOf("month"), start :this.moment().startOf("month") , endString : this.moment().endOf("month").format('DD/MM/YYYY'), startString : this.moment().startOf("month").format('DD/MM/YYYY')},
                    displayedMonths: [], // Liste des 4 mois visibles
                    itemdateDeb:{},
                    itemdateFin:{},          
                    parentModal : this.$store.getters.modalShowParams({ type: 'current', val: this.modalKey })['parent'],        
                    results : {},
                    datesearch : {},
                    debounceTimeout: null,
                    show : false,
                    //récupère juste les datas du back, si erreur, ca part dans not-allowed
                    datas : []
                }
            },


        watch: {
        '$route.query': {
            handler(newQuery) {
            const filteredQuery = Object.fromEntries(
                Object.entries(newQuery).filter(([key]) => key.startsWith(this.idmodule+"_"))
            );
            const advancedKey = this.idmodule + '__advanced';
            const advancedRaw = filteredQuery[advancedKey];
            delete filteredQuery[advancedKey];
            this.results = filteredQuery;

            try {
                const parsed = advancedRaw ? JSON.parse(advancedRaw) : {};
                this.advancedLogic = parsed.logic === 'or' ? 'or' : 'and';
                this.advancedConditions = Array.isArray(parsed.conditions) ? parsed.conditions : [];
            } catch (error) {
                this.advancedConditions = [];
            }

            // Conversion comme dans mounted()
            for (var pa in this.results) {
                if(typeof this.results[pa] === 'string' && /^-?(0|[1-9]\d*)(\.\d+)?$/.test(this.results[pa])) this.results[pa] = Number(this.results[pa]);
                if(this.results[pa] === 'false') this.results[pa] = false;
                if(this.results[pa] === 'true') this.results[pa] = true;

                if(Array.isArray(this.results[pa])) {
                this.results[pa] = this.results[pa].map(id => /^-?(0|[1-9]\d*)$/.test(String(id)) ? Number(id) : id);
                }
            }
            },
            immediate: true, // exécute au montage aussi
            deep: true       // si besoin
        }
        },

        computed: {
            advancedFieldOptions() {
                return [{text: 'Sélectionner', value: ''},
                    ...this.advancedFields.map(field => ({text: `${field.sourceTable} · ${field.name}`, value: `${field.sourceTable}::${field.cle}`}))];
            },

        },

            methods :  {    

                advancedField(condition) {
                    return this.advancedFields.find(field => field.sourceTable === condition.table && field.cle === condition.field);
                },
                advancedFormats(condition) {
                    const field = this.advancedField(condition);
                    return [field?.format, field?.searchFormat, field?.formFormat].filter(Boolean).map(format => format.toLowerCase());
                },
                advancedIsSwitch(condition) {
                    return this.advancedFormats(condition).includes('switch');
                },
                changeAdvancedSwitch(condition, value) {
                    condition.value = value;
                    this.launchSearch();
                },
                advancedHasChoices(condition) {
                    const field = this.advancedField(condition);
                    return !!field && this.advancedFormats(condition).some(format => ['select', 'autocomplete', 'radio'].includes(format))
                        && ['eq', 'neq'].includes(condition.op)
                        && (field.dynamicsearch || this.advancedChoiceOptions(condition).length > 0);
                },
                advancedChoiceOptions(condition) {
                    const field = this.advancedField(condition);
                    if (!field || !this.advancedFormats(condition).some(format => ['select', 'autocomplete', 'radio'].includes(format))
                        || !['eq', 'neq'].includes(condition.op)) return [];
                    const key = `${condition.table}::${condition.field}`;
                    const choices = [...(Array.isArray(field.liste) ? field.liste : []), ...(this.advancedDynamicChoices[key] || [])];
                    const options = choices.map(option => ({
                        text: option.text,
                        value: option[option.default || 'value']
                    })).filter(option => option.value !== undefined && option.value !== null && option.value !== '');
                    if (field.dynamicsearch) {
                        const selected = Array.isArray(condition.value) ? condition.value : [condition.value];
                        selected.forEach(value => {
                            if (value !== '' && value !== null && value !== undefined &&
                                !options.some(option => String(option.value) === String(value))) {
                                options.push({text: String(value), value});
                            }
                        });
                    }
                    return [...new Map(options.map(option => [String(option.value), option])).values()];
                },
                advancedSelectedValues(condition) {
                    const selected = Array.isArray(condition.value) ? condition.value : [condition.value];
                    const options = this.advancedChoiceOptions(condition);
                    return selected.map(value => options.find(option => String(option.value) === String(value))?.value)
                        .filter(value => value !== undefined);
                },
                changeAdvancedChoices(condition, values) {
                    condition.value = values || [];
                    this.launchSearch();
                },
                searchAdvancedChoices(condition, search) {
                    const field = this.advancedField(condition);
                    if (!field?.dynamicsearch || !search || search.length < 2) return;
                    const key = `${condition.table}::${condition.field}`;
                    clearTimeout(this.advancedChoiceTimers[key]);
                    this.advancedChoiceTimers[key] = setTimeout(() => {
                        this.$set(this.advancedChoiceLoading, key, true);
                        this.API({type:'post', url:'engine/reloadOptions',
                            params:{field:{table:field.sourceTable,cle:field.cle}, filter:{userSearch:search}}}).then(response => {
                            this.$set(this.advancedDynamicChoices, key, Array.isArray(response.data) ? response.data : []);
                        }).finally(() => this.$set(this.advancedChoiceLoading, key, false));
                    }, 300);
                },
                advancedInputType(condition) {
                    const formats = this.advancedFormats(condition);
                    if (formats.some(format => format.includes('date'))) return 'date';
                    if (formats.some(format => format.includes('number') || format === 'conversion')) return 'number';
                    return 'text';
                },
                advancedOperators(condition) {
                    const field = this.advancedField(condition);
                    const formats = this.advancedFormats(condition);
                    const common = [{text:'Est égal à',value:'eq'},{text:'Est différent de',value:'neq'},
                        {text:'Est vide',value:'empty'},{text:'N’est pas vide',value:'not_empty'}];
                    if (formats.includes('switch')) return [{text:'Est',value:'eq'}];
                    if (formats.some(type => ['select', 'autocomplete', 'radio'].includes(type)) && (field.dynamicsearch ||
                        (Array.isArray(field.liste) && field.liste.length))) return common;
                    if (formats.some(type => type.includes('date') || type.includes('number') || type === 'conversion')) return common.concat([
                        {text:'Supérieur à / après',value:'gt'},{text:'Supérieur ou égal',value:'gte'},
                        {text:'Inférieur à / avant',value:'lt'},{text:'Inférieur ou égal',value:'lte'},
                        {text:'Entre',value:'between'}]);
                    return [{text:'Contient',value:'contains'},{text:'Commence par',value:'starts_with'},
                        {text:'Se termine par',value:'ends_with'},...common];
                },
                addAdvancedCondition() {
                    if (this.advancedConditions.length >= this.advancedConfig.maxconditions) return;
                    this.advancedConditions.push({table: '', field: '', op: 'eq', value: ''});
                    this.launchSearch();
                },
                changeAdvancedField(condition, value) {
                    if (!value) {
                        condition.table = '';
                        condition.field = '';
                        condition.op = 'eq';
                        condition.value = '';
                        condition.value2 = '';
                        this.launchSearch();
                        return;
                    }
                    const field = this.advancedFields.find(item => `${item.sourceTable}::${item.cle}` === value);
                    if (!field) return;
                    condition.table = field.sourceTable;
                    condition.field = field.cle;
                    condition.op = this.advancedOperators(condition)[0].value;
                    condition.value = '';
                    condition.value2 = '';
                    this.launchSearch();
                },
                removeAdvancedCondition(index) {
                    this.advancedConditions.splice(index, 1);
                    this.launchSearch();
                },
                clearAdvancedConditions() {
                    this.advancedConditions = [];
                    this.launchSearch();
                },
                scheduleSearch() {
                    clearTimeout(this.debounceTimeout);
                    this.debounceTimeout = setTimeout(() => this.launchSearch(), 500);
                },

                getFieldResult(item) {
                    if((item.format=='autocomplete' || item.format=='select')) {
                        
                        if(item.defaultprops.multiple) {
                            return (!Array.isArray(this.results[this.idmodule+'_'+item.value])) ? [this.results[this.idmodule+'_'+item.value]] : this.results[this.idmodule+'_'+item.value];
                        } else {
                            return this.results[this.idmodule+'_'+item.value];                     
                        }

                    } else {
                        return this.results[this.idmodule+'_'+item.value];
                    }
                    
                },
    
                callAPI : function() {
                    this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,querys:this.results}}).then((resp) => {

                            this.manageDatas(resp.data)
                    })
    
                },

                manageDatas(datas) {
                    if(!datas.success) {
                        this.AllowedDisplay = false; 
                        this.datas = datas
                        return false;
                        }
                        this.list = datas.fields;
                        this.advancedFields = datas.advancedFields || datas.fields;
                        this.advancedConfig = {...this.advancedConfig,...(datas.advancedConfig || {})};
                        this.advancedConfig.maxconditions = Math.min(20, Math.max(1, Number(this.advancedConfig.maxconditions) || 20));
                        if (!this.$route.query[this.idmodule + '__advanced']) {
                            this.advancedLogic = this.advancedConfig.defaultlogic === 'or' ? 'or' : 'and';
                        }
                        this.datesearch = datas.datesearch
                        
                        this.itemdateDeb = {name:datas.datesearch.namedeb,value:this.idmodule+'_'+datas.datesearch.valuedeb,dateString:''}
                        this.itemdateFin = {name:datas.datesearch.namefin,value:this.idmodule+'_'+datas.datesearch.valuefin,dateString:''}
                        this.initializeDates(datas.datesearch)
                        this.show = true 
                },

                 onkeyup : function(item,model,enter) {
    
                    if(item.is =="search") {
                        this.results[item.value] = model
                        if(!model) this.results[item.value] = '';
                    } else {
                        this.results[this.idmodule+'_'+item.value] = model
                        if(!model) this.results[this.idmodule+'_'+item.value] = '';
                    }

                     
                     if(enter) {
    
                         this.launchSearch()
                         return;
                     }
                     this.scheduleSearch();
                 },

                onChange : function(item,model,selectedKey) {
                    var realValue = model;
                    if((item.format=='autocomplete' || item.format=='select')) {
                        realValue = [];
                        
                        if(item.defaultprops.multiple) {
                            model = model.filter(el => el!= undefined);
                            for(var selected in model) {
                                
                                if(typeof model[selected] == 'object') { realValue.push(model[selected][selectedKey]) } else { realValue.push(model[selected]); }
                            }
                        } else {
  
                        realValue = (typeof model =='object' && model!=null) ? model[selectedKey] : model;  
                          
                        }

                    } 
                    this.onkeyup(item,realValue)                         
                },

                launchSearch() {
                // épuration des querys du module : Étape 1 : Récupérer les query params actuels, en filtrant ceux qui ne commencent PAS par '125_'
                const filteredQuery = Object.fromEntries(
                Object.entries(this.$route.query).filter(([key]) => !key.startsWith(this.idmodule+"_"))
                );
                const ownQuery = {...this.results};
                // Garder les critères incomplets dans l'URL pour que vider une valeur ne supprime pas sa ligne.
                // Le back ignore ces critères tant qu'ils n'ont pas de valeur.
                if (this.advancedConfig.enabled && this.advancedConditions.length) {
                    ownQuery[this.idmodule + '__advanced'] = JSON.stringify({logic: this.advancedLogic, conditions: this.advancedConditions});
                }
                if(this.modal) {
                    this.$store.dispatch('changeOptionsModal',{modal:{type:'current',val:this.parentModal},type:'query',value:ownQuery});
                }
                const query = {...filteredQuery, ...ownQuery};
                this.$router.push({ query: query }).catch(() => {  });
                        
                },

                erase(is) {
                    switch(is) {
                        case 'end' :
                        this.results[this.itemdateFin.value] = ''
                        this.itemdateFin.dateString = 'N.D.'
                        this.menufin = false;
                        break;
                        case 'start':
                        this.results[this.itemdateDeb.value] = ''
                        this.itemdateDeb.dateString = 'N.D.'
                        this.menudeb = false;
                        break;
                    }
                    this.launchSearch();
                },


                initializeDates(apiData) {
                //si la date de début est affiché
                if(this.datesearch.setdebdate) {
                    //et qu'il y a une date de début par défaut dans le module on prend la date, sinon début de mois par défaut
                let deb = (apiData.defaultdeb!='' && apiData.defaultdeb!= null)
                    ? this.moment(apiData.defaultdeb, "YYYY-MM-DD")
                    : this.moment().startOf('month');
                    //si toute fois la query existe, on la prend
                    if(this.$route.query[this.itemdateDeb.value]) deb = this.moment(this.$route.query[this.itemdateDeb.value], "YYYY-MM-DD")

                    this.itemdateDeb.dateString = deb.format('YYYY-MM-DD')
                    this.results[this.itemdateDeb.value] = deb.format('YYYY-MM-DD');
                }
                if(this.datesearch.setfindate) {
                let fin = (apiData.defaultfin !='' && apiData.defaultfin!= null)
                    ? this.moment(apiData.defaultfin, "YYYY-MM-DD")
                    : this.moment().endOf('month');

                    if(this.$route.query[this.itemdateFin.value]) fin = this.moment(this.$route.query[this.itemdateFin.value], "YYYY-MM-DD")

                    this.itemdateFin.dateString = fin.format('YYYY-MM-DD')
                    this.results[this.itemdateFin.value] = fin.format('YYYY-MM-DD');
                }
                    //permet de lancer directement les dates dans $rtouer.query
                this.launchSearch()    
                this.updateDisplayedMonths();
                },

                onDateChange(model,type) {
                    if(type=='deb') { this.results[this.itemdateDeb.value] = model; this.menudeb = false;}
                    if(type=='fin') { this.results[this.itemdateFin.value] = model; this.menufin = false;}
                this.updateDisplayedMonths();
                this.launchSearch();
                },


                updateDisplayedMonths(prevOrNext) {
                    if(this.datesearch.setmonth) {
                        this.displayedMonths = [];
                        let indexMonth = (this.datesearch.setdebdate) ? this.moment(this.itemdateDeb.dateString).startOf('month') : this.moment().startOf('month') ;
                        let indexEndMonth = (this.datesearch.setfindate) ? this.moment(this.itemdateFin.dateString).endOf('month') : this.moment().endOf('month');

                        if(prevOrNext) {
                            indexMonth = this.moment(prevOrNext).startOf('month');
                            indexEndMonth = this.moment(prevOrNext).endOf('month');
                        } 

                        for (let i = 0; i < 4; i++) {
                            let startDate = indexMonth.clone().add(i, 'months').startOf('month');
                            let endDate = startDate.clone().endOf('month');

                            this.displayedMonths.push({
                                mois: startDate.month() + 1, // `moment().month()` retourne 0 pour janvier, donc +1
                                start: startDate.format('YYYY-MM-DD'),
                                end: endDate.format('YYYY-MM-DD'),
                                title: `du ${startDate.format('DD/MM/YYYY')} au ${endDate.format('DD/MM/YYYY')}`,
                                highlighted: startDate.isSameOrAfter(indexMonth) && endDate.isSameOrBefore(indexEndMonth)
                            });
                        }
                    }
                },

                selectMonth(mois) {
                //permet de mettre les résultats ds le filtre pour l'envoi dans $route.querys
                this.results[this.itemdateDeb.value] = mois.start;
                this.results[this.itemdateFin.value] = mois.end;
                //permet de mettre à jour l'affichage des dates dans le début et fin
                this.itemdateDeb.dateString = mois.start
                this.itemdateFin.dateString = mois.end
                //permet de modifier $router.query
                this.launchSearch();
                // permet de modifier l'highlight
                this.updateDisplayedMonths();
                },

                prevMonths() {
                    //récupère le premier array de this.displayedMonths
                    let firstdate = this.moment(this.displayedMonths[0]['start']);
                    let index = firstdate.clone().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                    this.updateDisplayedMonths(index)
                },

                nextMonths() {
                    //récupère le premier array de this.displayedMonths
                    let firstdate = this.moment(this.displayedMonths[0]['start']);
                    let index = firstdate.clone().add(1, 'months').startOf('month').format('YYYY-MM-DD');
                    this.updateDisplayedMonths(index)
                },

    
            },
            mounted() {
                var mod = this.$store.getters.modalShowParams({ type: 'current', val: this.modalKey })

                                if(this.modal && mod && mod.show) {
                                    this.results = {...this.results,...mod.query}
                                } else {

                                    const filteredQuery = Object.fromEntries(
                                    Object.entries(this.$route.query).filter(([key]) => key.startsWith(this.idmodule+"_"))
                                    );
                                    this.results = {...this.results,...filteredQuery}
                                }

                            // on check si une valeur est un nombre, alors on le converti en nombre en js
                            for( var pa in this.results) {
                                if(typeof this.results[pa] === 'string' && /^-?(0|[1-9]\d*)(\.\d+)?$/.test(this.results[pa])) this.results[pa] = Number(this.results[pa]);
                                if(this.results[pa]=='false') this.results[pa] = false;
                                if(this.results[pa]=='true') this.results[pa] = true;

                                if(Array.isArray(this.results[pa])) this.results[pa] = this.results[pa].map(id => /^-?(0|[1-9]\d*)$/.test(String(id)) ? Number(id) : id);
                            }

                            const advancedRaw = this.results[this.idmodule + '__advanced'];
                            delete this.results[this.idmodule + '__advanced'];
                            if (advancedRaw) {
                                try {
                                    const parsed = JSON.parse(advancedRaw);
                                    this.advancedLogic = parsed.logic === 'or' ? 'or' : 'and';
                                    this.advancedConditions = Array.isArray(parsed.conditions) ? parsed.conditions : [];
                                } catch (error) {
                                    this.advancedConditions = [];
                                }
                            }

                 
                let getdatas = this.$store.getters.getModuleDatas({page:this.modalKey,id:this.idmodule});
                if(getdatas) {
                    this.manageDatas(getdatas.datas)
                    this.$store.dispatch('removeModuleDatas',{page:this.modalKey,id:this.idmodule})
                } else {
                    this.callAPI() 
                }  
            },

            beforeDestroy() {
                clearTimeout(this.debounceTimeout);
                Object.values(this.advancedChoiceTimers).forEach(timer => clearTimeout(timer));
            },
    
            created() {  

            }
    
        }
    
    </script>

<style scoped>
.search-module { width: 100%; min-width: 0; }
.search-module__toggle { text-transform: none; letter-spacing: normal; }
.search-module__theme-button:not(.v-btn--disabled) {
    color: #fff !important;
    background-color: var(--app-form-button, #3f51b5) !important;
    border-color: var(--app-form-button, #3f51b5) !important;
}
.search-module__form { width: 100%; }
.search-module__field { min-width: 0; }
.search-module__field ::v-deep .v-input { width: 100%; margin-top: 0; }
.search-module__field ::v-deep .v-input__control { min-width: 0; }
.search-module__dates { padding-top: 0 !important; }
.search-module__date-button { height: 40px !important; text-transform: none; letter-spacing: normal; }
.search-module__date-button .text-truncate { min-width: 0; }
.search-module__date-card { width: 320px; max-width: calc(100vw - 24px); }
.search-module__months {
    display: grid;
    grid-template-columns: 34px repeat(4, minmax(42px, 1fr)) 34px;
    align-items: center;
    gap: 3px;
    min-height: 40px;
    overflow-x: auto;
}
.search-module__month { min-width: 42px; cursor: pointer; user-select: none; }
.search-module__month--hover { background-color: var(--app-tabs-active-background, #f0f1fa); }
.search-module__month--active { background-color: var(--app-form-button, #3f51b5) !important; }
.search-module__advanced-values { display: flex; align-items: center; min-width: 0; }
.search-module__advanced-values > * { min-width: 0; }
@media (min-width: 960px) {
    .search-module__simple-fields {
        flex-wrap: nowrap;
        align-items: flex-start;
        overflow-x: auto;
    }
    .search-module__field {
        flex: 1 1 0 !important;
        width: auto !important;
        max-width: none !important;
        min-width: 150px;
        padding-top: 4px;
        padding-bottom: 4px;
    }
    .search-module__dates {
        flex: 1 1 auto !important;
        width: auto !important;
        max-width: none !important;
        min-width: 190px;
        padding: 4px;
    }
    .search-module__dates > .row { flex-wrap: nowrap; }
    .search-module__dates > .row > .col {
        flex: 1 1 190px;
        width: auto;
        max-width: none;
        min-width: 190px;
    }
}
@media (max-width: 600px) {
    .search-module__simple-fields { margin: 0 !important; }
    .search-module__field { padding: 3px 0 !important; }
    .search-module__field ::v-deep .v-input__slot { margin-bottom: 2px; }
    .search-module__field ::v-deep .v-text-field__details { min-height: 12px; margin-bottom: 0; }
    .search-module__dates { padding: 5px 0 !important; }
    .search-module__advanced-values { flex-direction: column; align-items: stretch; gap: 6px; }
    .search-module__advanced-values ::v-deep .v-input { width: 100%; margin-left: 0 !important; }
}
</style>
